<template>
  <!-- Not logged in toolbar-->
  <v-toolbar app dense color="primary" v-if="! loggedIn" class="nav">
    <template v-if="$vuetify.breakpoint.smAndDown">
      <img :src="`/static/img/logo.${logoType}`" class="institute-logo"/>
      <v-spacer/>
      <personal-menu/>
    </template>
    <v-flex v-if="$vuetify.breakpoint.mdAndUp">
      <v-container class="py-0">
        <v-layout row>
          <img :src="`/static/img/logo.${logoType}`" class="institute-logo">
          <v-spacer/>
          <personal-menu/>
        </v-layout>
      </v-container>
    </v-flex>
  </v-toolbar>
  <!-- Logged in toolbar for mobile/desktop-->
  <v-toolbar app dense color="primary" v-else class="nav">
    <v-menu attach v-if="displayMobileMenu" offset-y transition="scale-transition">
      <v-btn icon slot="activator">
        <v-icon class="primary-text">menu</v-icon>
      </v-btn>
      <v-list>
        <v-list-tile v-for="nav in navs" :key="nav.id" :to="nav.destination? {name:nav.destination}: null">
          <v-list-tile-content>
            <v-list-tile-title>
              {{getTranslatedMenu(nav.text)}}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-menu>
    <v-flex v-if="$vuetify.breakpoint.mdAndUp">
      <v-container class="py-0">
        <v-layout row>
          <img :src="`/static/img/logo.${logoType}`" class="institute-logo pointer" @click="goDesktop">
          <v-btn v-for="nav in navs" :key="nav.id" flat :id="`menu_${nav.id}`"
                 :to="nav.destination? {name:nav.destination}: null" class="nav-btn">
            <span :style="textColor">{{getTranslatedMenu(nav.text)}}</span>
          </v-btn>
          <v-spacer/>
          <last-updated-date/>
          <announcement-icon/>
          <personal-menu/>
        </v-layout>
      </v-container>
    </v-flex>
    <v-spacer v-if="$vuetify.breakpoint.smAndDown"/>
    <img :src="`/static/img/logo.${logoType}`" v-if="$vuetify.breakpoint.smAndDown" class="institute-logo" :style="logoStyling"
         @click="goDesktop"/>
    <v-spacer v-if="$vuetify.breakpoint.smAndDown"/>
    <last-updated-date v-if="$vuetify.breakpoint.smAndDown"/>
    <announcement-icon v-if="$vuetify.breakpoint.smAndDown"/>
    <personal-menu v-if="$vuetify.breakpoint.smAndDown"/>
  </v-toolbar>
</template>

<script>
  import PersonalMenu from './PersonalMenu'
  import { mapActions, mapGetters, mapState } from 'vuex'
  import { LOGOUT } from '../../store/action-types'
  import { HAS_FEATURE_FLAG, IS_ADMIN, IS_STUDENT } from '../../store/getter-types'
  import Colors from '../../mixins/Colors'
  import AnnouncementIcon from '../announcement/AnnouncementIcon'
  import LastUpdatedDate from './LastUpdatedDate'

  const staffMenu = [
    {
      id: 'dashboard',
      destination: 'Dashboard',
      text: 'menu_dashboard'
    },
    {
      id: 'my_students',
      destination: 'Students',
      text: 'menu_my_students'
    },
    {
      id: 'menu_interactions',
      destination: 'Interactions',
      text: 'menu_intervention'
    }
  ]
  const adminMenu = [
    {
      id: 'feeds',
      destination: 'DailyFeeds',
      text: 'menu_feeds'
    },
    {
      id: 'insights',
      destination: 'Insights',
      text: 'menu_insights'
    }
  ]

  const studentMenu = [
    {
      id: 'menu_student_profile',
      destination: 'StudentHome',
      text: 'menu_student_profile'
    }
  ]

  const helpItem = [
    {
      id: 'help',
      destination: 'Help',
      text: 'help.link'
    }
  ]

  export default {
    components: {LastUpdatedDate, AnnouncementIcon, PersonalMenu},
    name: 'main-toolbar',
    mixins: [Colors],
    methods: {
      getTranslatedMenu (text) {
        return this.$t(text)
      },
      goDesktop () {
        this.$router.push('/goHome')
      },
      ...mapActions({
        'setLanguageFromDescription': 'setLanguageFromDescription',
        doLogout: LOGOUT
      })
    },
    computed: {
      ...mapGetters({
        isStudent: IS_STUDENT,
        isAdmin: IS_ADMIN,
        hasFeatureFlag: HAS_FEATURE_FLAG
      }),
      ...mapState({
        logoType: state => state.config.logoType,
        loggedIn: state => state.profile.loggedIn,
        moduleInterExem: state => state.profile.module.interexem,
        functionHeaderMenu: state => state.profile.functions.headerMenu,
        optionEnableInteractions: state => state.profile.options.enable.interactions
      }),
      logoStyling () {
        if (this.$vuetify.breakpoint.xsOnly) {
          return {maxWidth: '100px'}
        }
      },
      textColor () {
        return {color: this.getTextColor(this.$vuetify.theme.primary)}
      },
      displayMobileMenu () {
        return this.$vuetify.breakpoint.smAndDown
      },
      navs () {
        let key = this.isAdmin ? 'admin' : (this.isStudent ? 'student' : 'staff')
        return {
          'staff': this.buildStaffMenu.concat(helpItem),
          'admin': this.buildAdminMenu,
          'student': studentMenu.concat(helpItem)
        }[key]
      },
      buildStaffMenu () {
        return !this.flagEnableInteractions
          ? staffMenu.filter(el => el.destination !== 'Interactions')
          : staffMenu
      },
      buildAdminMenu () {
        return this.buildStaffMenu.concat(adminMenu, helpItem)
      },
      flagEnableInteractions () {
        return this.hasFeatureFlag(this.moduleInterExem + '.' + this.functionHeaderMenu + '.' + this.optionEnableInteractions)
      }
    }
  }
</script>

<style scoped>
  .nav {
    z-index: 4;
    position: fixed;
  }
  .nav-btn {
    min-width: 50px
  }
</style>



// WEBPACK FOOTER //
// src/components/navbar/MainToolbar.vue